
// http://121.36.13.81:4067/geoserver/satelliteview/wms?satelliteview:1540952798657-Countries

/* global  Cesium */

function getWMSLayer (layerinfo) {
  const oURL = layerinfo.url
  let _oURLname = oURL.split('?')[1]
  _oURLname = layerinfo.LAYERS
  const provider = new Cesium.WebMapServiceImageryProvider({
    url: oURL,
    layers: _oURLname,
    parameters: {
      service: 'WMS',
      format: 'image/png',
      transparent: true
    }
  })

  return provider
}

export { getWMSLayer }
